var _path, _polyline, _polyline2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorConvinienceStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.959,23.86l6.695-6.695c2.572,1.07,5.645.561,7.737-1.531,2.035-2.035,2.568-4.999,1.611-7.527l-3.903,3.903h-2.438s-1.809-1.809-1.809-1.809l.138-2.299,3.903-3.903c-2.528-.958-5.492-.425-7.527,1.611-2.092,2.092-2.6,5.165-1.531,7.737l-11.488,11.488c-2.572-1.07-5.645-.561-7.737,1.531-2.035,2.035-2.568,4.999-1.611,7.527l4.292-4.292h2.437s1.809,1.809,1.809,1.809l-.138,2.299-4.292,4.292c2.528.958,5.492.425,7.527-1.611,2.092-2.092,2.6-5.165,1.531-7.737l4.793-4.793"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "22.211 23.906 24.578 26.273 26.273 24.578 23.757 22.062"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "19.938 18.243 7.58 5.884 4.816 4 4 4.816 5.885 7.58 18.243 19.938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.902,32.262l-9.43-8.879-4.089,4.089,8.879,9.43c1.268,1.354,3.406,1.39,4.718.078h0c1.312-1.312,1.277-3.45-.078-4.718Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorConvinienceStore);
export default __webpack_public_path__ + "static/media/indoor-convinience_store.8dcf1f2f1b5ea3472b966f7671a91026.svg";
export { ForwardRef as ReactComponent };